import type { Environment } from 'config/environment'

import { getFactorialData } from 'modules/core/lib/cookie'
import hasFeature from 'modules/core/lib/hasFeature'

function initClarity({ clarityEnabled }: Environment) {
  const { isFactorial } = getFactorialData() || {}
  // TODO: Load only if there is consent
  // We are going to initially test the modal for asking consent to Factorial employees.
  // Later we will add the !user.analyticsConsent condition here.
  if (!clarityEnabled || isFactorial) return
  ;(function (c, l, a, r, i) {
    c[a] =
      c[a] ||
      function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }

    const t: any = l.createElement(r)
    t.async = 1
    t.src = 'https://www.clarity.ms/tag/' + i

    const y: any = l.getElementsByTagName(r)[0]
    y.parentNode.insertBefore(t, y)
  })(window, document, 'clarity', 'script', 'sqmqczevhl')
}

interface ClarityData {
  environment: Environment
  analyticsConsent: boolean | null | undefined
}

export default function runClarity({ environment, analyticsConsent }: ClarityData) {
  // ROLLOUT PHASE 1. Users without explicit consent (value set to null) still get through.
  // Only those with explicit "false" will avoid tracking
  if (analyticsConsent === false) return
  if (hasFeature('do_not_track')) return

  initClarity(environment)
}
